import { FaUserAlt } from 'react-icons/fa'
import { BiCurrentLocation, BiChevronRight } from 'react-icons/bi'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import logo from '../../../images/logo.png'
import logoPurple from '../../../images/logoPurple.png'

import { Container, Content } from './style'


export function Header({ setModalToFilterUserLocationOpen }) {
    const [scrollPosition, setScrollPosition] = useState(0)

    const cityDescription = JSON.parse(localStorage.getItem('@Inoveclube:location')).description
    const history = useHistory()

    let isScrollOnTop = scrollPosition === 0


    function handleClickToLogin() {
        localStorage.getItem('@Inoveclube:token') ?
            history.push('profile')
            :
            history.push('login')
    }

    function handleScroll() {
        setScrollPosition(window.pageYOffset)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)

        return () =>  window.removeEventListener('scroll', handleScroll);
    })



    return(
        <Container isScrollOnTop={isScrollOnTop}>
            <Content>
                <img 
                    src={isScrollOnTop ? logo : logoPurple}
                    alt={"logo inoveclube"}
                />


                <div className='buttons'>
                    <button onClick={handleClickToLogin}>
                        <FaUserAlt />
                        {
                            localStorage.getItem('@Inoveclube:token') ?
                            'Perfil'
                            :  
                            'Entrar'
                        } 
                    </button> 

                    <div
                        className='buttonLocation'
                        onClick={() => setModalToFilterUserLocationOpen(true)}
                    >
                        <BiCurrentLocation />
                        <p title={cityDescription}>{cityDescription}</p>
                        <BiChevronRight />
                    </div>
                </div>
            </Content>
        </Container>
    )
}